<template>
    <div>
        <!-- DIALOGO DE LOADING -->
        <Dialog :baseZIndex="2" :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }" :modal="true">
            <ProgressBar mode="indeterminate" style="height: 0.5em" />
            <span>{{ loadingMensaje }}</span>
        </Dialog>

        <!-- DIALOG DE LOS DETALLES -->
        <Sidebar :visible.sync="dialogDetalles" position="full" :showCloseIcon="false">
            <div class="card">
                <div>
                    <detalles @closeDialogComparativa="CloseComparativa"></detalles>
                </div>
            </div>
        </Sidebar>

        <div class="card">
            <div class="flex justify-content-center flex-wrap card-container">
                <div class="flex align-items-center justify-content-center w-14rem h-4rem m-2">
                    <span class="p-float-label">
                        <Calendar v-model="fechaI" dateFormat="dd-MM-yy" />
                        <label>Fecha Inicial</label>
                      </span>
                </div>
                <div class="flex align-items-center justify-content-center w-14rem h-4rem m-2">
                    <span class="p-float-label">
                        <Calendar v-model="fechaF" dateFormat="dd-MM-yy" />
                        <label>Fecha Final</label>
                      </span>
                </div>
                <div class="flex align-items-center justify-content-center w-4rem h-4rem m-2">
                    <div>
                        <Button icon="mdi mdi-text-box-search-outline" class="p-button-text p-button-rounded" @click="Consultar()" v-tooltip.bottom="'Consultar'" style="color:#FBC31F"/>
                    </div>
                    <div>
                        <Button icon="mdi mdi-file-excel-box" class="p-button-text p-button-rounded" @click="ExportExcel()" v-tooltip.bottom="'Exportar a Excel'" style="color:#107C41"/>
                    </div>
                </div>
            </div>
            <!-- TABLA DE TRABAJADORES -->
            <DataTable :value="itemTrabajadores" :scrollable="true" scrollHeight="600px" scrollDirection="both" :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10,20,50]"
            currentPageReportTemplate="{first} a {last} de {totalRecords}">
                <template #header>
                    <div class="text-center p-d-flex justify-center p-fluid grid formgrid">
                        <div class="col-12 text-center pa-0 ma-0 pl-3">
                            <h1>Trabajadores</h1>
                            <Button icon="mdi mdi-information" class="p-button-text p-button-rounded" @click="OpenNotas(1)" v-tooltip.bottom="'Información'" style="color:#24ACF2"/>
                        </div>
                    </div>
                </template>
                <Column header="Acciones" :styles="{'width':'1rem', 'min-width':'5rem'}" :exportable="false">
                    <template #body="slotProps">
                        <Button icon="mdi mdi-format-list-bulleted" class="p-button-text p-button-rounded" v-tooltip.bottom="'Detalle'" @click="OpenDialogDetalle(slotProps.data)" />
                    </template>
                </Column>
                <Column field="rfc" header="RFC" :styles="{'flex-grow':'1', 'flex-basis':'200px'}" sortable></Column>
                <Column field="curp" header="CURP" :styles="{'flex-grow':'1', 'flex-basis':'200px'}" sortable></Column>
                <Column field="nombre" header="Nombre" :styles="{'flex-grow':'1', 'flex-basis':'200px'}" sortable></Column>
                <Column field="edad" header="Edad" :styles="{'flex-grow':'1', 'flex-basis':'100px'}" sortable></Column>
                <Column field="periodicidad" header="Periodicidad Pago" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="tipoContrato" header="Tipo Contrato" :styles="{'flex-grow':'1', 'flex-basis':'300px'}"></Column>
                <Column field="tipoRegimen" header="Tipo Régimen" :styles="{'flex-grow':'1', 'flex-basis':'300px'}"></Column>
                <Column field="totalPercepciones" header="Percepciones" :styles="{'flex-grow':'1', 'flex-basis':'150px'}" sortable>
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.totalPercepciones) }}</span>
                      </template>
                </Column>
                <Column field="totalDeducciones" header="Deducciones" :styles="{'flex-grow':'1', 'flex-basis':'150px'}" sortable>
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.totalDeducciones) }}</span>
                      </template>
                </Column>
                <Column field="totalOtrosPagos" header="Otros Pagos" :styles="{'flex-grow':'1', 'flex-basis':'150px'}" sortable>
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.totalOtrosPagos) }}</span>
                      </template>
                </Column>
                <Column field="neto" header="Neto Pagado" :styles="{'flex-grow':'1', 'flex-basis':'150px'}" sortable>
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.neto) }}</span>
                      </template>
                </Column>
                <Column field="orinarias" header="# Nom. Ordinarias" :styles="{'flex-grow':'1', 'flex-basis':'120px'}" sortable></Column>
                <Column field="extraordinarias" header="# Nom. Extraordinarias" :styles="{'flex-grow':'1', 'flex-basis':'120px'}" sortable></Column>
                <Column field="puesto" header="Puesto" :styles="{'flex-grow':'1', 'flex-basis':'300px'}" sortable></Column>
                <Column field="departamento" header="Departamento" :styles="{'flex-grow':'1', 'flex-basis':'300px'}" sortable></Column>
            </DataTable>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'
    import { FilterMatchMode, FilterOperator } from "primevue/api/";
    import XLSX from 'xlsx'
    import detalles from './ReporteDetalles.vue'

    export default {
        components: {
            detalles
        },
        data() {
            return {
                itemTrabajadores: [],
                itemDetalles: [],
                fechaI: new Date(),
                fechaF: new Date(),

                //LOADING
                loading: false,
                loadingMensaje: '',

                //DETALLES
                dialogDetalles: false,

                rutaAxios : 'https://api-mongo.contago.com.mx/api/',
                // rutaAxios : 'https://localhost:44322/api/',
            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },
            
        },
        created() {

        },
        methods: {
            async Consultar(){
                this.loading = true;
                this.loadingMensaje = 'Consultando, espere...'
                let fI = moment(this.fechaI).format('YYYY-MM-DD')
                let fF = moment(this.fechaF).format('YYYY-MM-DD')
                try{
                    let response = await axios.get('ReporteNominas/GetReporteTrabajadores/'+ this.token.empresaBase + '/' + fI + '/' + fF);
                    this.itemTrabajadores = response.data;
                    this.loading = false;
                }catch(error){
                    console.log(error)
                    this.loading = false;
                }
            },

            async ConsultaMongo(){
                this.loading = true;
                this.loadingMensaje = 'Consultando, espere...'
                let fI = moment(this.fechaI).format('YYYY-MM-DD')
                let fF = moment(this.fechaF).format('YYYY-MM-DD')
                try{
                    let response = await axios.get(this.rutaAxios + 'Nomina/GetReporteTrabajadoresAsync/'+ this.token.empresaBase + '/' + fI + '/' + fF);
                    this.itemTrabajadores = response.data.general;
                    this.itemDetalles = response.data.detalles;
                    // console.log(response.data)
                    this.loading = false;
                }catch(error){
                    console.log(error)
                    this.loading = false;
                }
            },

            formatCurrency(value) {
                return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            },

            ExportExcel(){
                const nuevaLista = this.itemTrabajadores.map(item => {
                    const { ["_id"]: a, ["repeticiones"]: b, ...resto } = item;
                    return resto;
                });

                const workbook = XLSX.utils.book_new();
                const sheetTrabajadores = XLSX.utils.json_to_sheet(nuevaLista);
                XLSX.utils.book_append_sheet(workbook, sheetTrabajadores, 'TRABAJADORES');
                XLSX.writeFile(workbook, 'Reporte trabajadores.xlsx');
            },

            OpenDialogDetalle(item){
                console.log(item)
                let listaFiltrada = this.itemDetalles.filter(r => r.rfc === item.rfc);
                console.log(listaFiltrada);

                this.$store.state.isrDetallesStore.detalles = [ ...listaFiltrada ]
                this.$store.state.isrDetallesStore.tipo = item.rfc + ' | ' + item.nombre
                this.$store.state.isrDetallesStore.origen = 'TRABAJADORES'
                this.dialogDetalles = true;
            },

            CloseComparativa(){
                this.dialogDetalles = false;
            },
        },
    }
</script>